export const defaultEoi = {
    // contact details
    ua_companyname: null,
    ua_title: null,
    ua_othertitle: null,
    ua_firstname: null,
    ua_lastname: null,
    ua_preferredcontacttelephoneno: null,
    ua_emailaddress: null,
    ua_directornameformfa: null,
    ua_directoremailformfa: null,
    // business location
    ua_tradingaddressline1: null,
    ua_tradingaddressline2: null,
    ua_tradingaddresstowncity: null,
    ua_tradingaddresscounty: null,
    ua_tradingaddresspostcode: null,
    ua_tradingpostcodefromryi: null,
    ua_registeredaddresssameastrading: 2,
    ua_registeredaddressline1: null,
    ua_registeredaddressline2: null,
    ua_registeredaddresstowncity: null,
    ua_registeredaddresscounty: null,
    ua_registeredaddresspostcode: null,
    ua_registeredpostcodefromryi: null,
    // business details
    ua_website: null,
	ua_typeofbusinessownership: null,
	ua_businessownershipother: null,
	ua_companyregistrationnumber: null,
	ua_datestartedtrading: null,
	ua_utrnumber: null,
	ua_dateregisteredwithhmrc: null,
    ua_haveregisteredcharitystatus: null,
	ua_charitynumber: null,
	ua_dateregisteredwithcharitycommission: null,
    ua_registeredonmutualsregister: null,
    ua_mutualsregisterregistrationnumber: null,
	ua_areyouvatregistered: 2,
	ua_vatregistrationnumber: null,
    ua_sectorparentlookup: null,
	ua_sectornamefromryi: null,
    ua_umisector: null,
	ua_annualturnover: null,
	ua_financialyearend: null,
	ua_howmuchsalesdirecttopublic: null,
	ua_numberofemployees: null,
	ua_partofgroup: false,
	ua_groupname: null,
     ua_companygroupaddress: null,
	ua_companygrouppostcode: null,
	ua_companygrouprefno: null,
	ua_groupemployees: null,
	ua_groupturnover: null,
    ua_whatdoesthebusinessdo: null,
    // declarations
     ua_agreetodataprotection: null,
	ua_wheredidyouhearaboutus: null,
	ua_wheredidyouhearaboutusother: null,
	ua_pleasedescribeproject: null,
    ua_isbasedinengland: 0,
    ua_hasothersourcesoffunding: 0,
    ua_hasatleast1yearoffinancialaccounts: 0,
    // general
    ua_iccontractid: process.env.VUE_APP_CONTRACT_ID_EOI,
    ua_eoitype: 1,
    ua_icexpressionofinterestid: null,
    ua_sharepointfoldername: null,
     ua_submiteoi: 2,
    ua_currentstatus: null,
    ua_contact: null,
    ua_currentpageinapplication: null,
    ua_readyforfunding: null
};

export const defaultApplication = {
    // Business Financials
    ua_loanamount: '',
    ua_interestonlyperiod: '',
    ua_totalamountrequesting: '',
    ua_accesstoexternalfunding: '',
    ua_externalfundingdetail: '',
    ua_appliedforexternalfunding: '',
    ua_detailsoffinancialreporting: '',
    ua_doccopyofofferletters: '',
    ua_briefdescriptionoforganisation: '',
    ua_declarationcontractthresholds: '',
    ua_cashbalanceadditionalinfo: '',
    ua_doyouknowwhoyourmaincompetitorsare: '',
    ua_financialreportingsystems: '',
   //Company Overview
    ua_allattachmentspresent: false,
    ua_alldeclarationsticked: false,
    ua_declareinfoiscorrect: false,
    ua_leveragingexternalfinance: false,
    ua_ua_question22eighthpointanswertoggle: '',
    ua_ua_question22eleventhpointanswertoggle: '',
    ua_ua_question22fifthpointanswertoggle: '',
    ua_ua_question22fourthpointanswertoggle: '',
    ua_ua_question22ninthpointanswertoggle: '',
    ua_ua_question22secondpointanswertoggle: '',
    ua_ua_question22seventhpointanswertoggle: '',
    ua_ua_question22sixthpointanswertoggle: '',
    ua_ua_question22tenthpointanswertoggle: '',
    ua_ua_question22thirdpointanswertoggle: '',
    ua_restructure: '',
    ua_dpandprivacypolicyconsent: '',
    ua_declareumidiscretion: '',
    ua_declaretradinginarea: ''
};

export const STATUS_MAP = {
    eoi: {
        created: 0,
        'eoi-created': 0,
        'eoi-submitted': 1,
        'customer-app-submitted': 1,
        'customer-app-assessment-started': 2,
        'customer-app-in-assessment': 2,
        'eoi-in-assessment': 2,
        'customer-app-in-query': 3,
        'eoi-in-query': 3,
        ineligible: 4,
        'customer-app-rejected': 4,
        'customer-app-withdrawn': 5,
        'eoi-withdrawn': 5,
        withdrawn: 5,
        'customer-app-eligible': 6,
        eligible: 6

    },
    application: {
        created: 0,
        'application-created': 0,
        'application-submitted': 1,
        'customer-app-submitted': 1,
        'stage-2-assessment-started': 2,
        'assessment-complete': 2,
        'application-assigned': 2,
        'in-query-cust': 3,
        'in-query-customer': 3,
        'in-query-umi': 3,
        'app-in-query': 3,
        'application-rejected': 4,
        'application-withdrawn': 5,
        'offer-letter-signed': 6
    }
};
